<template>
    <div class="download-container">
        <div class="download-list">
            <component
                :is="item.link ? 'a' : 'span'"
                :href="item.link"
                v-for="(item, index) in downloadList"
                @click="handleClick(item)"
            >
                <div class="download-item">
                    <img
                        :src="themeMode === 'dark' ? item.darkIcon : item.icon"
                        class="download-icon"
                        :class="item.name"
                    />
                </div>
            </component>
        </div>

        <div class="divided"></div>

        <SplashSceen ref="splashScreen" :isComponent="true" />
    </div>
</template>

<script>
import icon_android from "../../../static/images/icons/aspn_icon/download/icon_android.png";
import icon_apple from "../../../static/images/icons/aspn_icon/download/icon_apple.png";
import icon_qr from "../../../static/images/icons/aspn_icon/download/icon_qr.png";
import icon_android_dark from "../../../static/images/icons/aspn_icon/download/icon_android_dark.png";
import icon_apple_dark from "../../../static/images/icons/aspn_icon/download/icon_apple_dark.png";
import icon_qr_dark from "../../../static/images/icons/aspn_icon/download/icon_qr_dark.png";

import SplashSceen from "../mobile/SplashSceen.vue";
import config from "../../js/config";
import { mapState } from "vuex";
export default {
    name: "DownloadIconList",
    data() {
        return {
            downloadList: [
                {
                    name: "android",
                    icon: icon_android,
                    darkIcon: icon_android_dark,
                    type: "png",
                    link: config.app.android.link,
                },
                {
                    name: "apple",
                    icon: icon_apple,
                    darkIcon: icon_apple_dark,
                    type: "png",
                    link: config.app.apple.link,
                },

                {
                    name: "qr",
                    icon: icon_qr,
                    darkIcon: icon_qr_dark,
                    type: "png",
                },
            ],
        };
    },
    components: {
        SplashSceen,
    },
    props: {
        divided: {
            type: Boolean,
        },
    },
    computed: {
        ...mapState(["themeMode"]),
    },
    methods: {
        handleClick(item) {
            if (!item.link) {
                if (item.name === "qr") {
                    this.$refs.splashScreen.parentOpenAndClose();
                }
            }
        },
    },
};
</script>

<style scoped>
.download-container {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-right: 16px;
}
.download-list {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    width: 100%;
}
.download-item {
    border-radius: 50%;
    width: 40px;
    height: 40px;
    background-color: var(--color-background-default-tertiary);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.download-item:hover {
    background-color: var(--color-background-default-tertiary-hover);
}
.download-icon {
    width: 32px;
    height: 32px;
}
.download-icon.qr {
    width: 26px;
    height: 26px;
}
.divided {
    width: 1px;
    height: 32px;
    background-color: var(--color-border-default-default);
}
</style>
